'use client';

import React from 'react';
import { domain_url } from '@/constants/apiConstant';
import { useGlobalContext } from '@/context/GlobalContext';
import HomeLayouts from '@/layouts/HomeLayouts';
import { filterIsAbroadCountry } from '@/utils/formatItems';
import { generateNumberBasedOnId } from '@/utils/generateCount';
import {
  generateAggregateRatingSchema,
  generateArticleSchema,
  generateDynamicBreadcrumbSchema,
  generateFAQSchema,
  generateWebPageSchema,
} from '@/utils/seo/schema';

import PageNavbar from '@/components/colleges/CollegeNavbar';
import HeroSection from '@/components/colleges/HeroSection';
import PageDetailsTab from '@/components/common/pageData/PageTabDetail';

const CollegePageComponent = ({ collegeData, collegeId, seoData, tab, isOnlineCollege, pageData }: any) => {

  const { setIsLeadFormOpen, setLeadFormData } = useGlobalContext();
  const pathValue = tab ?? 'college-info';
  const navbar = collegeData?.college_navbars;
  const isAbroadCollege = filterIsAbroadCountry(collegeData);
  const college_title = seoData?.[0]?.main_title ?? collegeData?.college_title;
  const rating = generateNumberBasedOnId(collegeData?.id, 4, 5);
  const reviews = generateNumberBasedOnId(collegeData?.id, 500, 2000);

  const college_url = isOnlineCollege
    ? `${domain_url}/colleges/${collegeData?.college_url}`
    : `${domain_url}/colleges/${collegeData?.college_url}/${tab}`;

  const handleOpen = (collegeId: any, collegeName: any, isAbroadCountry: boolean) => {
    setLeadFormData({
      source: `collegePage`,
      college: collegeId || null,
      title: collegeName || null,
      isAbroadCountry: isAbroadCountry ?? false,
    });
    setIsLeadFormOpen(true);
  };

  // const handleScroll = () => {
  //   if (window.scrollY > 200) {
  //     setTimeout(() => {
  //       window.scrollTo({
  //         top: 300,
  //         behavior: "smooth",
  //       });
  //     }, 100);
  //   }
  // };
  const title = collegeData?.abbreviation ?? collegeData?.college_name;
  const author_name = collegeData?.data?.updated_by_user?.name || collegeData?.created_by_user?.name;

  const webPageSchema = generateWebPageSchema(title, college_url);

  const faqData = pageData?.find((data: any) => data?.__component?.trim() === 'common.faq');
  const faqSchema = generateFAQSchema(faqData);

  const breadcrumbItems = generateDynamicBreadcrumbSchema(collegeData, isAbroadCollege, domain_url, college_url);

  const aggregateRatingSchema = generateAggregateRatingSchema(title, college_url, rating, `${reviews}`);
  const articleSchema = generateArticleSchema(
    title,
    domain_url,
    college_url,
    author_name,
    collegeData?.updatedAt,
    collegeData?.publishedAt,
    collegeData?.logo?.url,
  );

  return (
    <>
      
        {domain_url === 'https://collegehai.com' && collegeData?.college_url && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                speakable: {
                  '@type': 'SpeakableSpecification',
                  xpath: ['/html/head/title', '/html/body//h1', '/html/body//p[1]'],
                },
                url: college_url,
              }),
            }}
          />
        )}
        {domain_url === 'https://collegehai.com' && collegeData?.college_url && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(aggregateRatingSchema),
            }}
          />
        )}
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }} />
        {breadcrumbItems.length > 0 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: breadcrumbItems,
              }),
            }}
          />
        )}
        {faqSchema && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
        )}
        {articleSchema && (
          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }} />
        )}
      

      <HomeLayouts>
        <HeroSection
          collegeData={collegeData}
          college_title={college_title}
          handleOpen={handleOpen}
          isAbroadCollege={isAbroadCollege}
          breadcrumbItems={breadcrumbItems}
        />

        {/* Apply Now Button for Mobile */}
        <div className="mt-2 flex w-full justify-between gap-4 py-2 pr-2 font-inter text-sm md:hidden md:py-4">
          <button
            className="w-full rounded-md bg-secondary py-2 text-white duration-300"
            onClick={() => handleOpen(collegeData?.id, collegeData?.abbreviation, isAbroadCollege)}
          >
            Apply Now
          </button>
        </div>

        {/* Navbar Tabs */}
        {!isOnlineCollege && <PageNavbar entity="colleges" navbar={navbar} url={collegeId} pathValue={pathValue} />}

        {/* Tab Content */}
        <section className="min-h-96 w-full lg:mx-auto lg:max-w-screen-xl">
          <PageDetailsTab
            tabsData={pageData}
            page={collegeData}
            currentTab={pathValue}
            // loading={false}
          />
        </section>
      </HomeLayouts>
    </>
  );
};

export default CollegePageComponent;
